import React from 'react';
import useDocumentMeta from './useDocumentMeta';

function About() {
    useDocumentMeta({
        title: 'About Yay Fun, Inc. | Austin Software Product Studio',
        description: 'Yay Fun, Inc. is a software product studio in Northwest Austin, Texas, and the maker of PokeSwift and Social Bellow.',
        path: '/about',
    });

    return (
        <section className="page">
            <div className="container">
                <div className="page__head">
                    <p className="kicker">About</p>
                    <h1 className="page__title">A small studio that builds and runs real products.</h1>
                    <p className="page__lede">
                        Yay Fun, Inc. is a software studio in Northwest Austin, Texas. We design, develop,
                        and maintain our own software products.
                    </p>
                </div>

                <div className="about">
                    <div className="about__text">
                        <h2>What we do</h2>
                        <p>
                            We have been building for the web and mobile for more than a decade. Today that
                            means our own products, like PokeSwift, a point-of-sale app for trading card
                            vendors, and Social Bellow, an AI add-on for Adobe Express and Canva.
                        </p>
                        <p>
                            We handle everything in-house: product design, engineering, app store releases,
                            and the infrastructure that keeps each product running. We stay small on purpose
                            and focus on doing a few things well.
                        </p>
                    </div>

                    <aside className="about__facts card">
                        <dl>
                            <div>
                                <dt>Based in</dt>
                                <dd>Austin, Texas</dd>
                            </div>
                            <div>
                                <dt>Focus</dt>
                                <dd>Web apps, mobile apps, AI features, and platform add-ons</dd>
                            </div>
                            <div>
                                <dt>Our products</dt>
                                <dd>
                                    <a href="https://pokeswift.com" target="_blank" rel="noopener noreferrer">PokeSwift</a><br />
                                    <a href="https://socialbellow.com" target="_blank" rel="noopener noreferrer">Social Bellow</a>
                                </dd>
                            </div>
                            <div>
                                <dt>Contact</dt>
                                <dd>
                                    3616 Far West Blvd 117-414<br />
                                    Austin, TX 78731<br />
                                    <a href="tel:+15127295122">(512) 729-5122</a>
                                </dd>
                            </div>
                        </dl>
                    </aside>
                </div>
            </div>
        </section>
    )
}

export default About
